import React, { memo, useCallback, useEffect, useMemo, useRef } from 'react';
import { getFileById } from '@app/api';
import { cn } from 'lib/utils';

interface Props {
  placeholder: string;
  imageIds: string[];
  className?: string;
  alt?: string;
}

function LoadableImage(props: Props) {
  const { imageIds, placeholder, className = '', alt = '' } = props;
  const imageRef = useRef<HTMLImageElement>(null);

  const mainImageId = useMemo<string | null>(
    () => imageIds[0] || null,
    [imageIds]
  );

  const getImage = useCallback(async () => {
    try {
      if (!mainImageId || !imageRef.current) {
        return;
      }

      const image = await getFileById(mainImageId);

      imageRef.current.src = URL.createObjectURL(image);
    } catch (e) {}
  }, [mainImageId]);

  useEffect(() => {
    getImage();
  }, [getImage]);

  return (
    <img
      className={cn('w-full h-full object-cover', className)}
      src={placeholder}
      ref={imageRef}
      alt={alt}
    />
  );
}

export default memo(LoadableImage);
